// projects/state.js

export const projectsInitialState = {
  list: [],
  inactiveList: [],
  loading: false,
  error: null,
};
